import ActionArea from "../../components/ActionArea"
import Head from "../../components/Head"
import { DatePicker, Divider, message, Popover, Tooltip } from 'antd'
import Input from "../../components/UI/Input"
import { useEffect, useState } from "react"
import List from "../../components/List"
const { RangePicker } = DatePicker
import { exportCsvLogs, getLogsById, getLogsList } from "../../services/logs"
import Button from "../../components/UI/Button"
import LogsModal from "../../components/LogsModal"
import direction from "../../utils/filterDirectionOrder"
import React from "react"
import { notificationError } from "../../services/notification"
import { useLoading } from "../../context/LoadingProvider/useLoading"
import ModalSelector from "./ModalSelector"
import { CSVLink } from "react-csv"
import { PlusOutlined } from '@ant-design/icons';
//import dayjs from "../../utils/timezone"
import { sendSystemLog } from "../../context/AuthProvider/useAuth"
import SmartSearch from '../../components/UI/SmartSearch'
import dayjs from "dayjs";
import {convertToCentralSameTime, getCentralCurrentTime} from "../../utils/dateUtils";

function Logs() {
  const loading = useLoading()
  const [filter, setFilter] = useState({
    dateRange: [dayjs().subtract(1,'h'), dayjs()],
    search: '',
    limit: '1000',
    fieldOrder: '',
    directionOrder: '',
    action: '',
    objectType: '',
    objectName: '',
    user: '',
    location: '',
  })

  const [search, setSearch] = useState({
    text: '',
    id: '',
  })
  const [timerange, setTimeRange] = useState({
    range: '24 hours'
  })

  const centralCurrentTime = getCentralCurrentTime()
  const initDateStart = centralCurrentTime.format('YYYY-MM-DDTHH:mm:ss')
  console.log(`centralCurrentTime: ${centralCurrentTime}`)
  const LAST_HOUR = dayjs(initDateStart).subtract(1, "hour");
  const TODAY = dayjs(initDateStart);

  const onLocationChange = (e: any) => {
    setSearch({ ...search, id: e.id })
    onFitlerChange('location', e.id)
    if(e.id === null || e.id === '') {
      setTimeRange({ ...timerange, range: '24 hours'})
    } else {
      setTimeRange({ ...timerange, range: '1 month'})
    }
  }

  const [lastOrder, setLastOrder] = useState({
    column: {},
    field: '',
    order : ''
  })

  const [prevFilter, setPrevFilter] = useState({
    dateRange: [dayjs().subtract(1,'h'), dayjs()],
    search: '',
    limit: '1000',
    fieldOrder: '',
    directionOrder: '',
    action: '',
    objectType: '',
    objectName: '',
    user: '',
    location: '',
  })

  const [csv, setCsv] = useState('')
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [logInfo, setLogInfo] = useState({
    changes: {},
    full: {
        "new info": {},
        "old info": {}
    }
  })
  const [logsList, setLogsList] = useState({
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  })
  const [modal, setModal] = useState({
    action: false,
    objectType: false
  })
  const onFitlerChange = (name: string, value: any) => {
    if (name==='limit'){
      if (value> 10000) value = 10000;
      if (value < 1) value = 1;
    }
    setFilter({
      ...filter,
      [name]: value
    })
  }
  const log = {
    log_type: 'visited',
    log_object: 'log'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  const onRefresh = async (order?: string, directionparam?: string, page?: number) => {
    if((order || directionparam) && logsList.count === 0) return

    const dateStart = dayjs(filter.dateRange[0].valueOf()).format('YYYY-MM-DDTHH:mm:ss')
    const dateEnd = dayjs(filter.dateRange[1].valueOf()).format('YYYY-MM-DDTHH:mm:ss')
    let dayjsStart = convertToCentralSameTime(dateStart)
    let dayjsEnd = convertToCentralSameTime(dateEnd)

    if(filter.location === null || filter.location === '') {
      if(dayjs(dateEnd).diff(dayjs(dateStart), 'hours') > 24) {
        notificationError('Time range cannot exceed 24 hours')
        return
      }
    } else {
      if(dayjs(dateEnd).diff(dayjs(dateStart), 'days') > 30) {
        notificationError('Time range cannot exceed 1 month')
        return
      }
    } 
    

    loading.addLoading()
    let params = {
      dateIntervalStart: dayjsStart.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      dateIntervalEnd: dayjsEnd.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      search: filter.search,
      limit: filter.limit,
      action: filter.action,
      objectType: filter.objectType,
      objectName: filter.objectName,
      user: filter.user,
      fieldOrder: '',
      directionOrder: '',
      location: filter.location,
    }

    if((order && directionparam) || page) {
      params = {
        dateIntervalStart: dayjs(prevFilter.dateRange[0]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        dateIntervalEnd: dayjs(prevFilter.dateRange[1]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        search: prevFilter.search,
        limit: prevFilter.limit,
        action: prevFilter.action,
        objectType: prevFilter.objectType,
        objectName: prevFilter.objectName,
        user: prevFilter.user,
        fieldOrder: order || '',
        directionOrder: (directionparam && directionparam === 'ascend' ? direction.asc : direction.desc) || '',
        location: prevFilter.location,
      }

    } else {
      setPrevFilter({
        ...filter,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      })
      setFilter({
        ...filter,
        fieldOrder: order || '',
        directionOrder: directionparam === 'ascend' ? direction.asc : direction.desc,
      })
    }
/*     const res = await exportCsvLogs(params)
    setCsv(res) */
    const logs = await getLogsList(params)
    if(logs) setLogsList(logs)
    loading.removeLoading()
  }

  const getLogs = async (id: string) => {
    const logInfo = await getLogsById({id})
    setLogInfo(logInfo)
    setIsModalVisible(true)
  }

  const onChangeOrder = (order: {column: any, field: string, order: string| undefined}, pagination: {current: number}) => {
    let columncheck =(order.field === null && lastOrder.field !== null)
        || (order.field!==null && lastOrder.field === null)
        || (order.field!==null && lastOrder.field !== null && order.field !== lastOrder.field)
    let ordercheck = false;
    if (!order.order && lastOrder.order !=='') {
      ordercheck = true;
    } else if (order.order && order.order !== lastOrder.order) {
      ordercheck = true;
    }
    if(columncheck
        || ordercheck) {
      setLastOrder({column: order.column, field: order.field, order: order.order || ''});
      order.field = resolveColumnNames(order.field)
      pagination.current = 1;
      return onRefresh(order.field, order.order, pagination.current)
    }
  }

  const resolveColumnNames = (column : string ) => {
    if (column==='objectName') return 'object_name';
    if (column==='portalUserName') return 'portal_user_name';
    return column;
  }
  const headers = [
    { label: 'Time', key: 'timestamp' },
    { label: 'Action', key: 'action' },
    { label: 'Object Type', key: 'object' },
    { label: 'Object Name', key: 'objectName' },
    { label: 'User', key: 'portalUserName' },
    { label: 'IP', key: 'ip' },
    { label: 'Location', key: 'lname' },
    { label: 'Old Info', key: 'oldInfo' },
    { label: 'New Info', key: 'newInfo' },
  ];

  return (
    <div className="logs">

      <LogsModal 
        isModalVisible={isModalVisible} 
        info={logInfo} 
        handleOk={()=> setIsModalVisible(false)} 
        handleCancel={()=> setIsModalVisible(false)} 
      />
      <ModalSelector 
        visible={modal.action} 
        type="action" 
        title="Select your action" 
        onSelectChange={(e: string) => setFilter({...filter, action: e})}
        onClose={() => setModal({...modal, action: false})}
      />
      <ModalSelector 
        visible={modal.objectType} 
        type="objectType" 
        title="Select your object type" 
        onSelectChange={(e: string) => setFilter({...filter, objectType: e})}
        onClose={() => setModal({...modal, objectType: false})}
      />
      <CSVLink style={{display: logsList?.list?.length > 0 ? 'flex' : 'none'}}
               filename={"logs.csv"}
               className="floating-button"
               data={logsList.list}
               headers={headers}>
        <PlusOutlined style={{color: '#FFF', fontSize: window.innerWidth > 600 ? 20 : 16}} />
        <div className="floating-button__text">
          Export CSV
        </div>
      </CSVLink>
      <ActionArea buttonText={'Search'} buttonAction={()=> onRefresh()} buttonStyle={{marginBottom: -10}} style={{paddingBottom: '15px'}}>
        <>
          <Input
            onChange={(e:any) => onFitlerChange('search', e.target.value)}
            value={filter.search}
            label='Search Details'
            style={{marginBottom: -10}}
          />
          <Input
            onChange={(e:any) => onFitlerChange('limit', e.target.value)}
            value={filter.limit}
            label='Limit'
            type="number"
            style={{marginBottom: -10}}
          />
  
          <div className="input-component">
            <div className="input-component__label">
              Date Interval (Max range: {timerange.range})
            </div>
            <div className="input-component__input">
              <RangePicker
                onChange={(e: any)=> onFitlerChange('dateRange', e)}
                defaultValue={[LAST_HOUR, TODAY]}
                format={'MM-DD-YYYY HH:mm:ss'}
                showTime
                allowClear={false}
              />
            </div>
          </div>
          <SmartSearch
            label="Smart Search"
            searchBy={['location']}
            value={search.text} 
            onChange={(e) => setSearch({ ...search, text: e })} 
            onObjValueChange={e => onLocationChange(e)} 
            validOnEmpty 
          />
          <div className="logs__controls__disclaimer">
          </div>
          <Input
            onChange={(e:any) => onFitlerChange('action', e.target.value)}
            value={filter.action}
            label='Action'
            style={{marginBottom: -10}}
          />
          <Button 
            type="primary" 
            onClick={() => setModal({...modal, action: true})}
            style={{marginBottom: 10, height: 32, marginTop: 'auto', marginRight: 20}}
          >
            <p>Action List</p>
          </Button>
          <Input
            onChange={(e:any) => onFitlerChange('objectType', e.target.value)}
            value={filter.objectType}
            label='Object Type'
            style={{marginBottom: -10}}
          />
          <Button 
            type="primary" 
            onClick={() => setModal({...modal, objectType: true})}
            style={{marginBottom: 10, height: 32, marginTop: 'auto', marginRight: 20}}
          >
            <p>Object Type List</p>
          </Button>
          <Input
            onChange={(e:any) => onFitlerChange('objectName', e.target.value)}
            value={filter.objectName}
            label='Object Name'
            style={{marginBottom: -10, width: 280}}
          />
          <Input
            onChange={(e:any) => onFitlerChange('user', e.target.value)}
            value={filter.user}
            label='User'
            style={{marginBottom: -10}}
          />
        </>
      </ActionArea>
      <div>{logsList.count} Records</div>
      <List
        rows={logsList.list}
        onChange={(pagination, filters, sorter) => onChangeOrder(sorter, pagination)}
        pagination
        columns={[
          {
            title: 'Time',
            dataIndex: 'timestamp',
            key: 'timestamp',
            //render: (value: string) => dayjs(value).format('MM-DD-YYYY HH:mm:ss'),
            render: (value: string) => dayjs(value).utc(true).local().tz('America/Chicago').format('MM-DD-YYYY HH:mm:ss z'),
            sorter: true,
          },
          {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (value: any, record: any) => value ,
            sorter: true,
          },
          {
            title: 'Object Type',
            dataIndex: 'object',
            key: 'object',
            render: (value: any, record: any) => value ,
            sorter: true,
          },
          {
            title: 'Object Name',
            dataIndex: 'objectName',
            key: 'objectName',
            render: (value: any, record: any) => value ,
            sorter: true,
          },
          {
            title: 'User',
            dataIndex: 'portalUserName',
            key: 'portalUserName',
            render: (value: string) => value,
            sorter: true,
          },
          {
            title: 'IP',
            dataIndex: 'ip',
            key: 'ip',
            render: (value: string) => value,
            sorter: true,
          },
          {
            title: 'Location',
            dataIndex: 'lname',
            key: 'lname',
            render: (value: string) => value,
            sorter: true,
          },
          {
            title: 'Details',
            dataIndex: 'id',
            key: 'id',
            render: (value: string, record: any) =>( 
              record.oldInfo === '{}' && record.newInfo === '{}' ? 
                'no details' 
                  :
                <Button onClick={() => getLogs(value)} type="primary"><p>Details</p></Button>
              ),
          },
        ]}
      />
    </div>
  )
}

export default Logs
